/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type BeforeDateValueConfigKind = (typeof BeforeDateValueConfigKind)[keyof typeof BeforeDateValueConfigKind];

export const BeforeDateValueConfigKind = {
  before: 'before',
} as const;
